import { Iterable } from "@siteimprove/alfa-iterable";
import { Predicate } from "@siteimprove/alfa-predicate";
const { equals } = Predicate;
export function hasId(idOrPredicate = () => true, ...ids) {
    let predicate;
    if (typeof idOrPredicate === "function") {
        predicate = idOrPredicate;
    }
    else if (typeof idOrPredicate === "string") {
        predicate = equals(idOrPredicate, ...ids);
    }
    else {
        predicate = (value) => Iterable.includes(ids, value);
    }
    return (element) => element.id.some(predicate);
}
//# sourceMappingURL=has-id.js.map